import { Component, OnInit } from '@angular/core';
import { Capacitor, Plugins } from '@capacitor/core';

import { Platform, AlertController } from '@ionic/angular';
import { Router, NavigationEnd } from '@angular/router';
import { CommonService } from '../app/services/common.service';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { DataService } from 'src/app/services/data.service';
import { IResponseDto, IPushRegDto, PushRegisterPageVM } from '../../src/app/models/common.models';
import { url } from 'inspector';
import { Badge } from '@ionic-native/badge/ngx';
const { StatusBar, SplashScreen } = Plugins;
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  public selectedIndex = 0;
  public appPages = [
    {
      title: 'Home',
      url: '/home',
      icon: 'home',
      // image: url('../assets/menuicons/exam.svg')
    },
    {
      title: 'DashBoard',
      url: '/dashboard',
      icon: 'dash'
    },
    {
      title: 'Fee',
      url: '/fee',
      icon: 'pay'
    },
    {
      title: 'Student Info',
      url: '/student',
      icon: 'student'
    },
    {
      title: 'Announcements',
      url: '/announcements',
      icon: 'announcement'
    },
    {
      title: 'Circulars',
      url: '/circular',
      icon: 'circular'
    },
    {
      title: 'Exams',
      url: '/exams',
      icon: 'exam'
    },
    {
      title: 'Attendance',
      url: '/attendance',
      icon: 'attendence'
    },
    {
      title: 'Gallery',
      url: '/gallery',
      icon: 'gallery'
    },
    {
      title: 'School Calendar',
      url: '/calendar',
      icon: 'calender'
    },
    {
      title: 'Change Password',
      url: '/changepassword',
      icon: 'changepassword'
    },
    {
      title: 'Logout',
      url: '/logout',
      icon: 'logout'
    }
  ];
  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  private blackLists: string[] = ['/home', '/dashboard', '/fee', '/student', '/announcements', '/circular', '/exams',
    '/attendance', '/gallery', '/calendar', '/changepassword'];

  public parentname: string;
  public apikey: string;
  vmpush = PushRegisterPageVM;
  // = sessionStorage.getItem('displayName');
  constructor(
    private platform: Platform,
    private router: Router,
    public commonSvc: CommonService,
    private alertCtrl: AlertController,
    public dataSvc: DataService,
    private oneSignal: OneSignal,
    private badge: Badge
  ) {
    this.initializeApp();
    this.commonSvc.getItem('displayName').then(response => {
      this.parentname = response;
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Show StatusBar
      const isSbAvailable = Capacitor.isPluginAvailable('StatusBar');
      if (isSbAvailable) {
        StatusBar.show();
        StatusBar.setOverlaysWebView({
          overlay: false
        });
        StatusBar.setBackgroundColor({
          color: '#6a8af9'
        });
      }
      // Hide the splash (you should do this on app launch)
      SplashScreen.hide();
      // SplashScreen.show({
      //   autoHide: false
      // });
      // Display content under transparent status bar (Android only)

      // this.badge.set(20);
      // this.badge.increase(1);
      // this.badge.clear();

      if (this.platform.is('cordova') || this.platform.is('capacitor')) {
        this.setupPush();
        // this.badge.increase(1);
      }

      // this.getApiKey().then(() => {
      //   console.log(this.apikey);
      //   if (this.apikey !== '') {
      //     this.router.navigate(['/home']);
      //   } else if (this.apikey == null) {
      //     this.router.navigate(['/login']);
      //     return false;
      //   }
      // });

      // this.platform.backButton.subscribeWithPriority(9999, () => {
      //   document.addEventListener('backbutton', (event) => {
      //     event.preventDefault();
      //     event.stopPropagation();
      //   }, false);
      // });
      // this.platform.backButton.subscribeWithPriority(99, () => {
      // });

      // this.router.events.subscribe((ev) => {
      //   if (ev instanceof NavigationEnd) {
      //     const blackList = this.blackLists.find(el => ev.url.includes(el));
      //     if (blackList) {
      //       this.enableBack();
      //     } else {
      //       this.disableBack();
      //     }
      //   }
      // });
    });
  }

  ngOnInit() {
    this.getStorageData().then(() => {
      const path = window.location.pathname.split('folder/')[1];
      if (path !== undefined) {
        this.selectedIndex = this.appPages.findIndex(page => page.title.toLowerCase() === path.toLowerCase());
      }
    });
  }

  async getApiKey() {
    this.commonSvc.getItem('apikey').then(response => {
      this.apikey = response;
    });
  }
  ionViewDidEnter() {
    this.commonSvc.getItem('displayName').then(response => {
      this.parentname = response;
    });
  }
  ionViewWillEnter() {
    this.commonSvc.getItem('displayName').then(response => {
      this.parentname = response;
    });
  }
  ionViewWillLeave() {
    this.commonSvc.getItem('displayName').then(response => {
      this.parentname = response;
    });
  }
  ionViewDidLeave() {
    this.commonSvc.getItem('displayName').then(response => {
      this.parentname = response;
    });
  }
  private logger() {
    console.log('disable back button');
  }
  // disableBack() {
  //   document.addEventListener('backbutton', this.logger, false);
  // }

  // enableBack() {
  //   document.removeEventListener('backbutton', this.logger, false);
  // }
  // logOut() {
  //   this.clearStorageData().then(() => {
  //     this.router.navigateByUrl('login');
  //   });
  // }
  async getStorageData() {
    this.commonSvc.getItem('displayName').then(response => {
      this.parentname = response;
    });
  }

  async clearStorageData() {
    await this.commonSvc.clear();
  }

  // async registerUserOneSignal(playerid) {
  //   await this.commonSvc.showLoader();
  //   await this.dataSvc.registeruseronesignal(playerid).then((response: IResponseDto<IPushRegDto>) => {
  //     this.commonSvc.hideLoader();
  //     if (response != null && response.status !== 'Error') {
  //       this.vmpush = response;
  //     } else {
  //       this.vmpush.message = response.message;
  //     }
  //     console.log(this.vmpush);
  //   });
  // }

  setupPush() {
    this.oneSignal.startInit('3dd43478-2085-416a-8ace-134d2bdc11dc', '320107443194');
    // this.oneSignal.startInit('3dd43478-2085-416a-8ace-134d2bdc11dc', '320107443194').subscribe(response => {
    //   // this.commonSvc.setItem('onesignalkey', response.userId);
    //   let tokenid = response.userId;
    //   let device = response.device;
    //   this.registerUserOneSignal(tokenid);
    // });
    // let onesignalstatus: OSPermissionSubscriptionState = this.oneSignal.getPermissionSubscriptionState();
    // let token = onesignalstatus.subscriptionStatus.userId;

    this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None);

    this.oneSignal.getIds().then(res => {
      const playerid = res.userId;
      const pushtoken = res.pushToken;
      console.log(res);
      this.commonSvc.setItem('onesignalkey', res.userId);
      // this.registerUserOneSignal(playerid);
    });

    // Notifcation was received in general
    this.oneSignal.handleNotificationReceived().subscribe(data => {
      let msg = data.payload.body;
      let title = data.payload.title;
      let additionalData = data.payload.additionalData;
      this.badge.increase(1);
      this.showAlert(title, msg, additionalData.task);
    });

    // Notification was really clicked/opened
    this.oneSignal.handleNotificationOpened().subscribe(data => {
      // Just a note that the data is a different place here!
      let additionalData = data.notification.payload.additionalData;
      this.badge.clear();

      this.showAlert('Notification opened', 'You already read this before', additionalData.task);
    });

    this.oneSignal.endInit();
  }
  async showAlert(title, msg, task) {
    const alert = await this.alertCtrl.create({
      header: title,
      subHeader: msg,
      buttons: [
        {
          text: `Action: ${task}`,
          handler: () => {
            // E.G: Navigation to a specific screen
          }
        }
      ]
    });
  }

}
